/**
 * List Schema of CargaPesquisaSatisfacao
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaPesquisaSatisfacao} from '@/model/resource/CargaPesquisaSatisfacao'

/* TODO: review generated schema */
export class ListCargaPesquisaSatisfacaoSchema extends Schema {
  readonly name = 'ListCargaPesquisaSatisfacao'

  readonly fieldSet: FieldSet<CargaPesquisaSatisfacao> = {
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    notaPergunta1: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    notaPergunta2: (): FieldComponent => ({
      is: Component.Render,
    }),
    urlFotoSilenciosa: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
